"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "caselle-lurani": {
    "02b241da": [{
      "hkey": "49bb7aa7",
      "slug": "caselle-lurani",
      "name": "Caselle Lurani",
      "primary": true,
      "skipSearch": false
    }],
    "cascine": [{
      "hkey": "49bb7aa7",
      "slug": "caselle-lurani",
      "name": "Caselle Lurani",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9268b895": [{
      "hkey": "49bb7aa7",
      "slug": "caselle-lurani",
      "name": "Caselle Lurani",
      "primary": true,
      "skipSearch": false
    }],
    "case-sparse-san-gabriele": [{
      "hkey": "49bb7aa7",
      "slug": "caselle-lurani",
      "name": "Caselle Lurani",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3016c434": [{
      "hkey": "49bb7aa7",
      "slug": "caselle-lurani",
      "name": "Caselle Lurani",
      "primary": true,
      "skipSearch": false
    }],
    "cusanina": [{
      "hkey": "49bb7aa7",
      "slug": "caselle-lurani",
      "name": "Caselle Lurani",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9cc9023d": [{
      "hkey": "49bb7aa7",
      "slug": "caselle-lurani",
      "name": "Caselle Lurani",
      "primary": true,
      "skipSearch": false
    }],
    "del-pozzo": [{
      "hkey": "49bb7aa7",
      "slug": "caselle-lurani",
      "name": "Caselle Lurani",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9b7f15c6": [{
      "hkey": "e3a370fc",
      "slug": "caselle-lurani-paese",
      "name": "Caselle Lurani paese",
      "primary": true,
      "skipSearch": false
    }],
    "lurani": [{
      "hkey": "e3a370fc",
      "slug": "caselle-lurani-paese",
      "name": "Caselle Lurani paese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "078cb0fc": [{
      "hkey": "49bb7aa7",
      "slug": "caselle-lurani",
      "name": "Caselle Lurani",
      "primary": true,
      "skipSearch": false
    }],
    "moschinone": [{
      "hkey": "49bb7aa7",
      "slug": "caselle-lurani",
      "name": "Caselle Lurani",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "04e69237": [{
      "hkey": "49bb7aa7",
      "slug": "caselle-lurani",
      "name": "Caselle Lurani",
      "primary": true,
      "skipSearch": false
    }],
    "san-geminiano": [{
      "hkey": "49bb7aa7",
      "slug": "caselle-lurani",
      "name": "Caselle Lurani",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;